import React, { Component } from 'react'
import PopupWindow from './PopupWindow'
import { connect } from 'react-redux';
import * as StatisticActions from '../../actions/statisticActions';
import { bindActionCreators } from 'redux';
import Checkbox from './Checkbox'
import StatsBaseWindow from './StatsBaseWindow'

class GameStatsWindow extends StatsBaseWindow {    
    
    render() {        
        const { close_stats_window } = this.props.StatisticActions;

        return (<PopupWindow header="Статистика Матча" width={420} is_cut_down={this.props.is_cut_down} onDragStop={this.onDragStop.bind(this)} onToggleCutDown={this.onToggleCutDown.bind(this)} top={this.position.top}  left={this.position.left} onClose={() => (close_stats_window(this.props.id))}>
                    <table className="match_stat">
                        <tr>
                            <th className="match_stat_header">{this.props.homeTeam.Name}</th>
                            <th className="match_stat_header_center"></th>
                            <th className="match_stat_header">{this.props.awayTeam.Name}</th>
                        </tr>
                        <tr>
                            <td>{this.props.stats.Shots.Home}</td>
                            <td>Удары</td>
                            <td>{this.props.stats.Shots.Away}</td>
                        </tr>
                        <tr>
                            <td>{this.props.stats.ShotsOnGoal.Home}</td>
                            <td>В створ</td>
                            <td>{this.props.stats.ShotsOnGoal.Away}</td>
                        </tr>
                        <tr>
                            <td>{this.props.stats.XG.Home}</td>
                            <td>xG</td>
                            <td>{this.props.stats.XG.Away}</td>
                        </tr>
                        <tr>
                            <td>{this.props.stats.Shots.Home-this.props.stats.ShotsOnGoal.Home}</td>
                            <td>Мимо ворот</td>
                            <td>{this.props.stats.Shots.Away-this.props.stats.ShotsOnGoal.Away}</td>
                        </tr>
                        <tr>
                            <td>{this.props.stats.BlockedShots.Home}</td>
                            <td>Блокированные</td>
                            <td>{this.props.stats.BlockedShots.Away}</td>
                        </tr>
                        <tr>
                            <td>{this.props.stats.Possession.Home}</td>
                            <td>Владение</td>
                            <td>{this.props.stats.Possession.Away}</td>
                        </tr>
                        <tr>
                            <td>{this.props.stats.Offsides.Home}</td>
                            <td>Офсайды</td>
                            <td>{this.props.stats.Offsides.Away}</td>
                        </tr>
                        <tr>
                            <td>{this.props.stats.Corners.Home}</td>
                            <td>Угловые</td>
                            <td>{this.props.stats.Corners.Away}</td>
                        </tr>
                        <tr>
                            <td>{this.props.stats.Fouls.Home}</td>
                            <td>Фолы</td>
                            <td>{this.props.stats.Fouls.Away}</td>
                        </tr>
                        <tr>
                            <td>{this.props.stats.FreeKicks.Home}</td>
                            <td>Штрафные</td>
                            <td>{this.props.stats.FreeKicks.Away}</td>
                        </tr>
                        <tr>
                            <td>{this.props.stats.Penalty.Home}</td>
                            <td>Пенальти</td>
                            <td>{this.props.stats.Penalty.Away}</td>
                        </tr>
                        <tr>
                            <td>-</td>
                            <td>Голевые моменты</td>
                            <td>-</td>
                        </tr>
                        <tr>
                            <td>-</td>
                            <td>Точные передачи</td>
                            <td>-</td>
                        </tr>
                        <tr>
                            <td>-</td>
                            <td>Выиграно единоборств</td>
                            <td>-</td>
                        </tr>
                        <tr>
                            <td>-</td>
                            <td>Воздушные единоборства</td>
                            <td>-</td>
                        </tr>
                    </table>
                </PopupWindow>)
    }
}

function mapStateToProps(state, ownProps) {
    return {
      position: state.statisticWindows[ownProps.id].position,
      is_cut_down: state.statisticWindows[ownProps.id].is_cut_down,
      homeTeam: state.HomeTeam,
      awayTeam: state.AwayTeam,
      stats: state.Stats
    };
}

function mapDispatchToProps(dispatch) {
    return {
        StatisticActions: bindActionCreators(StatisticActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GameStatsWindow)



/** WEBPACK FOOTER **
 ** ./src/components/PopupStats/GameStatsWindow.js
 **/